export default {
  common: {
    casino: "Casino",
    more: "Más",
    searchGames: "Buscar juegos",
    copied: "¡Copiado!",
    inputTooLong: "La entrada es demasiado larga, por favor vuelva a ingresarla.",
    inputNameCn: "Solo se permiten caracteres chinos, letras, números y guion bajo",
    inputCapital: "Solo se permiten letras mayúsculas y guion bajo",
    inputLowercaseUnderscore: "Solo se permiten letras minúsculas y guion bajo",
    inputLowercase: "Solo se permiten letras minúsculas",
    inputNoSpace: "Por favor, no ingrese solo espacios",
    inputValidPhone: "Por favor, ingrese un número de teléfono válido",
    inputNonNumber: "Contiene caracteres no numéricos",
    inputNonLetter: "Contiene caracteres que no son letras",
    inputLetterOrNumberOnly: "Solo se permiten letras o números",
    phoneFormatError: "Formato de número de teléfono inválido",
    inputLetterStartNumber: "Debe comenzar con una letra y puede contener números",
    inputNoChinese: "No se permiten caracteres chinos",
    inputChineseOnly: "Solo se permiten caracteres chinos",
    emailFormatError: "Formato de correo electrónico inválido",
    urlFormatError: "Formato de URL inválido",
    jsonFormatError: "Formato JSON inválido",
    networkError: "No se pudo conectar con el servidor, inténtelo de nuevo más tarde.",
    siteUnavailable: "Este sitio no está disponible actualmente, comuníquese con el administrador.",
    tokenExpired: "Su sesión ha expirado, inicie sesión de nuevo.",
    domainNotAuthorized: "Dominio no autorizado",
    demoEnvOnly: "Entorno de demostración, solo para vista previa",
    passwordLength630: "6-30 caracteres",
    newPasswordSameAsOld: "La nueva contraseña no puede ser igual a la anterior",
    confirmNewPassword: "Por favor, confirme su nueva contraseña",
    passwordsDoNotMatch: "Las contraseñas no coinciden",
    withdrawPasswordChanged: "Contraseña de retiro cambiada con éxito",
    withdrawPasswordSet: "Contraseña de retiro establecida con éxito",
    withdrawPasswordSetFailed: "No se pudo establecer la contraseña de retiro",
    phoneDigitsOnly: "El número de teléfono debe contener solo dígitos",
    phoneTooShort: "El número de teléfono es demasiado corto (mín. {min} dígitos)",
    phoneTooLong: "El número de teléfono es demasiado largo (máx. {max} dígitos)",
    phoneInvalidPrefix: "Prefijo de número de teléfono inválido",
    rolloverAll: "Todos los tipos",
    rolloverAllStats: "Todos los estados",
    rolloverSuccessful: "Exitoso",
    rolloverFailed: "Fallido",
    rolloverInProgress: "En curso",
    rolloverSuccess: "Éxito",
    rolloverPending: "Pendiente",
    rolloverCompleted: "Completado",
    rolloverCancelled: "Cancelado",
    rolloverExpired: "Expirado",
    walletCash: "Efectivo",
    walletBonus: "Bono",
    sourceDeposit: "Depósito",
    sourceCommission: "Comisión",
    sourceManualAdd: "Adición manual",
    sourceManualSubtract: "Resta manual",
  },
  redeemCode: {
    enterTip: "Ingresa tu código de canje para reclamar recompensas",
    placeholder: "Por favor ingresa tu código",
    redeemBtn: "CANJEAR",
    pleaseEnterCode: "Por favor ingresa tu código de canje",
    redeemSuccess: "¡Canje exitoso!",
    redeemFailed: "Canje fallido, inténtalo de nuevo",
  },
}
